import img1 from '/static/img/experience/activities/sampleActivities/img1.png'
import img2 from '/static/img/experience/activities/sampleActivities/img2.png'
import img3 from '/static/img/experience/activities/sampleActivities/img3.png'
import img4 from '/static/img/experience/activities/sampleActivities/img4.png'
import img5 from '/static/img/experience/activities/sampleActivities/img5.png'
const sampleActivitiesInfo = {
    title:'Sample Activities',
    desc:'Each leg of your journey will feature different activities depending on the route. Here are some of the activities planned for our journey.',
    img1:img1,
    img2:img2,
    img3:img3,
    img4:img4,
    img5:img5
}
export default {
    sampleActivitiesInfo
};